let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8eXtb"), load("6qah4"), load("7ABT7"), load("8wMGm"), load("aZinD"), load("6gqpV"), load("4m5MY")]).then(() => parcelRequire('j89ZI'));